<bit-form-field>
  <bit-label class="">{{ "verificationCode" | i18n }}</bit-label>
  <input type="password" bitInput appAutofocus appInputVerbatim [formControl]="tokenFormControl" />
</bit-form-field>
